/**
 * Default constants for the chatbot library.
 */

/** Fallback response when the chatbot cannot answer from the knowledge base. */
export const FALLBACK_RESPONSE =
  "I don't have information about that in my knowledge base. Please contact support for further assistance.";

/** Maximum number of characters allowed in the input field. */
export const MAX_INPUT_LENGTH = 500;

/** Character count at which the remaining-characters indicator becomes visible. */
export const CHAR_COUNT_THRESHOLD = 400;

/** Minimum interval (ms) between consecutive message submissions. */
export const RATE_LIMIT_COOLDOWN_MS = 1000;

/** Maximum time (ms) to wait for an LLM provider response before timing out. */
export const REQUEST_TIMEOUT_MS = 30_000;

/** Maximum number of conversation history messages sent to the LLM provider. */
export const MAX_HISTORY_MESSAGES = 20;

/** Default title displayed in the chat panel header. */
export const DEFAULT_TITLE = 'Chat';

/** Default aria-label for the chat panel dialog. */
export const DEFAULT_ARIA_LABEL = 'Chat assistant';

/** Default label for the support link in the fallback response. */
export const DEFAULT_SUPPORT_LABEL = 'Contact Support';
